/**
 * Everything the client needs to know about where it is running.
 *
 * The API is same-origin in production, where Nginx proxies /api to the Node
 * process, and proxied by Vite in development. Neither case needs a host, so
 * there is nothing here to get wrong per environment.
 */
export const appConfig = {
  apiBase: '/api',
  /** Where the tutor lands after signing in. */
  appHome: '/user'
} as const;
